/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {RenderDocument} from "js_renderer";

import AbstractModule from "../abstract_module";
import {vec2, vec3} from "gl-matrix";
import IViewModule from "./scene_view_interface";
import Scene from "../../scene";
import Settings from "../settings";

interface IView {
    name: string;
    cameraPosition: vec3;
    cameraTarget: vec3;
    fieldOfView?: number;
}
interface IViewModuleSettings {
    views?: IView[];
}

export default
class ViewModule extends AbstractModule implements IViewModule {

    protected static _typeName: string = "view";

    protected _defaultSettings: IViewModuleSettings;
    protected _settings: IViewModuleSettings;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this._type = ViewModule._typeName;

        this._defaultSettings = {
            views: []
        };

        this._settings = Settings.clone(this._defaultSettings);

        let view = this.sceneAPI.viewModeModule.getActiveView();
        if (view) {
            view.registerViewChangedObserver(this);
        }
    }

    public static getClassType(): string {
        return ViewModule._typeName;
    }

    public getDefaultViewpoint() {
        return this._settings.views[0];
    }

    public getCurrentViewpoint() {
        return this._settings.views[1];
    }

    public viewChanged() {
        let camera = this.sceneAPI.viewControlsModule.getCamera();
        // update current camera
        vec3.copy(this._settings.views[1].cameraPosition, camera.getCameraPosition());
        vec3.copy(this._settings.views[1].cameraTarget, camera.getCameraTarget());
        this._settings.views[1].fieldOfView = camera.getFieldOfView();
    }

    public viewResized(aContentSize: vec2) {
    }

    public setFromModelDescription(aJsonObject: any) {
        let settings: IViewModuleSettings = {};

        // backward compatibility
        if (aJsonObject.hasOwnProperty("views")) {
            /*let modelConfig: any = aJsonObject.ModelConfiguration;
            if (modelConfig.hasOwnProperty("showLayerWindowAtStart")) {
                settings.showLayerWindowAtStart = modelConfig.showLayerWindowAtStart;
            }*/
        }
        // end backward compatibility

        if (aJsonObject.hasOwnProperty(this.getType())) {
            settings = aJsonObject[this.getType()];
        }

        this.set(settings);
    }
}

Scene.registerSceneAPIModule(ViewModule);
